module.exports = __webpack_public_path__ + "img/Business-Notifications-Dark.ecdfecd2.png";